import React, { Component } from 'react'
import Header from './Header'
import { FiArrowLeft } from "react-icons/fi";
import { IoMdImages } from "react-icons/io";
import { LocationContext } from './context'
import PlacesAutocomplete, {
    geocodeByAddress,
    getLatLng,
} from 'react-places-autocomplete';
import { Link } from 'react-router-dom'
export default class PostAddress extends Component {
    constructor(props) {
        super(props);
        this.state = { address: '', title: '', des: '', LatLng: {} };
    }

    handleChange = address => {
        this.setState({ address });
    };

    handleSelect = address => {
        this.setState({ address });
        geocodeByAddress(address)
            .then(results => getLatLng(results[0]))
            .then(latLng => { this.setState({ LatLng: latLng }) });
    };
    submitAd = () => {
        const { changeLocation } = this.context
        let { address, title, des, LatLng } = this.state
        if (address != '' && title != '' && des != '') {
            const loc = {
                address: address,
                title: title,
                des: des,
                LatLng: LatLng
            }
            changeLocation(loc);
            this.setState({ address: '', title: '', des: '', LatLng: {} })
        }
        else {
            alert('Fill All Fields!')
        }
    }
    static contextType = LocationContext
    render() {
        const { changeLocation } = this.context
        const hStyle = {
            flex: 1,
            margin: 0,
            textAlign: 'center',
            marginRight: 60,
            fontWeight: 'bold',
            letterSpacing: '2px'
        }
        const content = {
            display: 'flex',
            flexDirection: 'column',
            margin: '0px auto',
            justifyContent: 'center', alignItems: 'center'
            // textAlign: 'center',
        }
        const inputStyle = {
            background: '#fff',
            color: '#000',
            padding: '20px 0px 0px',
            border: 'none',
            fontSize: 20,
            outline: 'none',
            maxWidth: "300px",
            marginBottom: 10,
        }
        const LInputStyle = {
            background: '#fff',
            color: '#000',
            padding: '20px 0px',
            border: 'none',
            fontSize: 20,
            outline: 'none',
            maxWidth: "300px",
            marginBottom: 20,

        }
        return (
            <div>
                <Header>
                    <Link to='/'>
                        <FiArrowLeft style={{ width: '60px', fontSize: '30px', color: '#FFF', textAlign: 'center' }} />
                    </Link>
                    <h2 style={hStyle}>LOGO</h2>
                </Header>
                <div style={content}>
                    <div style={{ padding: 10, textAlign: 'center' }}>
                        <IoMdImages style={{ width: '60px', color: "#d50320", fontSize: '75px', textAlign: 'center' }} />
                        <p style={{ fontSize: 20, marginTop: -7, color: '#d50320', fontWeight: '500' }}>Add a Photo</p>
                    </div>
                    <div>
                        <div style={{}}>
                            <p style={{ fontSize: 19, marginBottom: 10, fontWeight: 'bold', marginTop: 35, }}>Property Address</p>
                            {/* <input style={inputStyle}
                                type='text'
                                placeholder='Search Address' /> */}
                            <PlacesAutocomplete
                                value={this.state.address}
                                onChange={this.handleChange}
                                onSelect={this.handleSelect}
                            >
                                {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
                                    <div>
                                        <input
                                            style={inputStyle}
                                            type='text'
                                            placeholder='Search Address'
                                            {...getInputProps({
                                                placeholder: 'Search Places ...',
                                                className: 'location-search-input',
                                            })}
                                        />
                                        <div className="autocomplete-dropdown-container">
                                            {loading && <div>Loading...</div>}
                                            {suggestions.map(suggestion => {
                                                const className = suggestion.active
                                                    ? 'suggestion-item--active'
                                                    : 'suggestion-item';
                                                // inline style for demonstration purpose
                                                const style = suggestion.active
                                                    ? { backgroundColor: '#fafafa', cursor: 'pointer' }
                                                    : { backgroundColor: '#ffffff', cursor: 'pointer' };
                                                return (
                                                    <div
                                                        {...getSuggestionItemProps(suggestion, {
                                                            className,
                                                            style,
                                                        })}
                                                    >
                                                        <span>{suggestion.description}</span>
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    </div>
                                )}
                            </PlacesAutocomplete>
                            <hr />
                            <p style={{ fontSize: 19, marginBottom: 10, fontWeight: 'bold', marginTop: 35, }}>Property Title</p>
                            <input style={inputStyle}
                                type='text'
                                value={this.state.title}
                                onChange={(e) => this.setState({ title: e.target.value })}
                                placeholder='Your property title' />
                            <hr />
                            <p style={{ fontSize: 19, marginBottom: 10, fontWeight: 'bold', marginTop: 35, }}>Describe more about your property</p>
                            <input style={LInputStyle}
                                type='text'
                                value={this.state.des}
                                onChange={(e) => this.setState({ des: e.target.value })}
                                placeholder='Enter any notes here...' />

                            <div>
                                <button style={{
                                    background: '#d50320',
                                    color: '#fff',
                                    padding: '15px 20px',
                                    borderRadius: '50px',
                                    border: 'none',
                                    fontSize: 20,
                                    outline: 'none'
                                }} onClick={this.submitAd}>
                                    POST YOUR AD
                            </button>

                            </div>

                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
